module.exports = __webpack_public_path__ + "static/media/hands-usd.9eeb8178.svg";